import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import FormControl from "react-bootstrap/FormControl";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Select,
} from '@mantine/core';

import { connect /*, useDispatch*/ } from 'react-redux';
import { store } from '../app/store';

import { UPDATE_ACTIVE_STATUS, ALERT_STATUS_CHANGE_FROM_DROPDOWN } from "../features/actions/My-Assigned-Tickets-Actions";

//import { ADD_DEPARTMENT, SHOW_ADD_DEPARTMENT_FORM, CHANGE_ACTIVE_DEPARTMENT, RESET_DEPARTMENT, ALERT_DEPARTMENT_CHANGE_FROM_DROPDOWN } from '../features/actions/Dynamic-Table-Actions';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href="#chosenStatus"
    ref={ref}
    id="selectStatusDropdownButton"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    &#x25bc;
  </a>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto gothamNarrowLightFont"
          placeholder="Type to filter..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value),
          )}
        </ul>
      </div>
    );
  },
);


// function resetDepartment() {
//   return {
//     type: 'RESET_DEPARTMENT'
//   }
// }

function updateActiveStatus(status_name) {
  return {
    type: 'UPDATE_ACTIVE_STATUS',
    payload: status_name
  }
}

function alertAboutStatusChange() {
  return {
    type: 'ALERT_STATUS_CHANGE_FROM_DROPDOWN'
  }
}

function handleStatusChange(status_name) {
  let state = store.getState();

  // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
  if (status_name !== state.myAssignedTickets.status_name) {

    //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
    store.dispatch(updateActiveStatus(status_name));
    store.dispatch(alertAboutStatusChange()); // tell My-Assigned-Tickets.js to run it's componentDidUpdate fxn and get new assigned ticket data
  }


}

function StatusSelector() {
  let state = store.getState();
  //let dispatch = useDispatch();

  return (
    <>
      <Select
        label="Status"
        placeholder="Pick value"
        data={["All", "Open", "On Hold", "Open And On Hold", "Resolved"]}
        //defaultValue={state.myAssignedTickets.status_name}
        value={state.myAssignedTickets.status_name}
        display="inline-block"
        onChange={(s) => handleStatusChange(s)}
        w="200px"
        allowDeselect={false}
      />
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    myAssignedTickets: state.myAssignedTickets
  };
}

export default connect(mapStateToProps, { UPDATE_ACTIVE_STATUS, ALERT_STATUS_CHANGE_FROM_DROPDOWN })(StatusSelector);